import Header from "./Header";
import ResponsiveMenu from "./ResponsiveMenu";

const header = new Header();
const menu = document.querySelector("[data-responsive-menu]");

header.init();

if (menu) {
  // eslint-disable-next-line no-new
  new ResponsiveMenu({
    menu,
    menuItems: [...document.querySelectorAll("[data-responsive-menu-item]")],
    dropdown: document.querySelector("[data-responsive-menu-dropdown]"),
    dropdownItems: [
      ...document.querySelectorAll("[data-responsive-menu-dropdown-item]"),
    ],
    dropdownTrigger: document.querySelector(
      "[data-responsive-menu-dropdown-trigger]"
    ),
  });
}

// Overwrite SVG fill color in tags list in header
(() => {
  const paths = document.querySelectorAll(".page-tags__tag svg path");

  if (paths) {
    paths.forEach((path) => {
      const fillValue = path.getAttribute("fill");

      if (fillValue === "#009DAD") {
        path.setAttribute("fill", "#0CC6DE");
      }
    });
  }
})();
